import { useState, useEffect, useRef } from 'react';
import Router from 'next/router';
import Countdown from 'react-countdown';
import useSound from 'use-sound';
import Checkbox from '@mui/material/Checkbox';
import { ColorPicker } from 'material-ui-color';
import Select, { components } from "react-select";
import Button from '@mui/material/Button';
import PauseIcon from '@mui/icons-material/Pause';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DesktopDatePicker from '@mui/lab/DesktopDatePicker';

import TimePicker from 'components/otimepicker/withdropdown';

import { v4 as uuidv4 } from 'uuid';
import TextField from '@mui/material/TextField';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import moment from 'moment';
import { extendMoment } from 'moment-range';
const _moment = extendMoment(moment);
import Image from 'next/image';
import FormControl from '@mui/material/FormControl';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DangerousIcon from '@mui/icons-material/Dangerous';
import DialogTitle from '@mui/material/DialogTitle';

import AccessAlarmSharpIcon from '@mui/icons-material/AccessAlarmSharp';
import LoopIcon from '@mui/icons-material/Loop';
import { useTranslations } from 'next-intl';

import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Snackbar from '@mui/material/Snackbar';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { countdownsState } from 'store/atoms';










const sounds = [{
    key: null,
    name: 'None',

}, {
    key: 'alarm_fast_high.mp3',
    name: 'Fast high',

}, {
    key: 'iphone_alarm.mp3',
    name: 'Alarm',
}]



// Renderer callback with condition
const renderer = ({ days, hours, minutes, seconds, completed, props }) => {
    // console.log("==renderer===", props);
    // Render a countdown
    return <div style={{ color: props.color, fontFamily: props.blockstyle.value }} className="digital_clock_style">
        {days ? `${days}` : '00'}<span style={{ color: props.color }} className='days-span'>{`Days`}</span>
        {props.keyFiguration !== 'onlydays' ? `${hours.toString().length < 2 ? `0${hours}` : hours}:${minutes.toString().length < 2 ? `0${minutes}` : minutes}:${seconds.toString().length < 2 ? `0${seconds}` : seconds}` : ''}
    </div>;

};
const NoOptionsMessage = props => {
    return (
        <components.NoOptionsMessage {...props}>
            <span className="custom-css-class">{t('key_not_found')}</span>
        </components.NoOptionsMessage>
    );
};
const ClearInd = () => (<svg style={{ cursor: "pointer" }} width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.46 7L14 12.54V14H12.54L7 8.46L1.46 14H0V12.54L5.54 7L0 1.46V0H1.46L7 5.54L12.54 0H14V1.46L8.46 7Z" fill="#444D67" />
</svg>);


const ClearIndicator = (props) => {
    const {
        children = <ClearInd />,
        getStyles,
        innerProps: { ref, ...restInnerProps },
    } = props;
    return (
        <div
            {...restInnerProps}
            ref={ref}
            style={getStyles('clearIndicator', props)}
        >
            <div style={{ padding: '0px 5px' }}>{children}</div>
        </div>
    );
};





const DropdownIndicator = props => {
    if (!props.hasValue && !props.selectProps.menuIsOpen) {
        return (
            <components.DropdownIndicator {...props} >
                <svg width="10" height="5" viewBox="0 0 10 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 0L5 5L10 0H0Z" fill="#152141" />
                </svg>
            </components.DropdownIndicator>

        )
    }
    if (!props.hasValue && props.selectProps.menuIsOpen) {
        return (
            <components.DropdownIndicator {...props} >
                <svg width="10" height="5" viewBox="0 0 10 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10 5L5 -4.37114e-07L0 5L10 5Z" fill="#444D67" />
                </svg>
            </components.DropdownIndicator>
        )
    }
    return null

};




export default function Main({ _timer, cancelDisplay, index, fullscreenfn = null, exrtaProps, timerObj, alreadyAdded, singleTimer, _openmore = true }) {

    const predefined = {
        timer: _timer ? Date.now() + _timer : Date.now(),
        keyFiguration: timerObj?.keyFiguration,
        hideDateTitle: timerObj?.hideDateTitle,
        datetime: _timer ? moment().set({
            hour: 0,
            minute: 0,
            second: 0,
            millisecond: 0,
        }).add(_timer, 'millisecond').format() : null,
        datetimer: timerObj?.datetimer,
        initial: _timer ? _timer : 0,
        title: timerObj?.title || '',
        times: timerObj?.times || null,
        timepickerDefault: timerObj?.timepickerDefault || {
            hours: 0,
            minutes: 0,
            seconds: 0
        },
        blockstyle: timerObj?.blockstyle || {
            label: 'Minimalistic',
            value: 'Arial'
        },
        text_colors: timerObj?.text_colors || {
            date_time: '#8A90A0',
            digits: '#152141',
        },
        bg: timerObj?.bg || {
            is_color: true,
            value: '#FFFFFF'
        }


    };

    const [timepickerDefault, setTimepickerDefault] = useState(predefined.timepickerDefault);
    const [title, setTitle] = useState(predefined.title);
    const [hideDateTitle, setHideDateTitle] = useState(predefined.hideDateTitle || false);
    const [openmore, setOpenmore] = useState(_openmore);
    const [playing, setPlaying] = useState({});
    const [previewAudio, setPreviewAudio] = useState(null);
    const [sound, setSound] = useState(null);
    const [times, setTimes] = useState(predefined.times);

    const [blockstyle, setBlockstyle] = useState(predefined.blockstyle);
    const [colorTime, setColorTime] = useState(predefined.text_colors.date_time);
    const [colorDigit, setColorDigit] = useState(predefined.text_colors.digits);
    const [bg, setBg] = useState(predefined.bg);

    const [keyFiguration, setKeyFiguration] = useState(predefined.keyFiguration || 'alldate');

    const [alarmset, setAlarmset] = useState(false);
    const [timer, setTimer] = useState(predefined.timer);
    const [datetimer, setDatetimer] = useState(predefined.datetimer ? predefined.datetimer : predefined.timer);
    const [datetime, setDatetime] = useState(predefined.datetime);
    const [initial, setInitial] = useState(predefined.initial);
    const [openAlarm, setOpenAlarm] = useState(false);
    const [repeated, setRepeated] = useState(false);
    const countdowns = useRecoilValue(countdownsState);
    const setCountdowns = useSetRecoilState(countdownsState);
    const [mounted, setMounted] = useState(false);

    const [started, setStarted] = useState(false);
    const [address, setAddress] = useState('');
    const [error, setError] = useState(false);
    const [countdownApi, setCountdownApi] = useState(null);
    const [play, { stop }] = useSound('/iphone_alarm.mp3');
    const t = useTranslations();

    const blockStyles = [
        {
            label: t('Minimalistic'),
            value: 'Arial'
        }, {
            label: t('Bold'),
            value: 'Play'
        }, {
            label: t('Handwriting'),
            value: 'Charmonman'
        }
    ];




    const EmptyBorderIcon = () => {
        return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.5" y="0.5" width="23" height="23" rx="3.5" stroke="#B9BCC6" />
        </svg>
        )
    };
    const EmptyRadioIcon = () => {
        return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="11.5" stroke="#B9BCC6" />
        </svg>

        )
    };

    const FillIcon = () => {
        return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="24" height="24" rx="4" fill="rgb(3, 201, 215)" />
            <path d="M21 7L9 19L3.5 13.5L4.91 12.09L9 16.17L19.59 5.59L21 7Z" fill="white" />
        </svg>

        )
    }
    const FillRadioIcon = () => {
        return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="11.5" stroke="#B9BCC6" />
            <circle cx="12" cy="12" r="6" fill="rgb(3, 201, 215)" />
        </svg>


        )
    }
    const bgImages = [
        {
            title: t('Love'),
            value: 'Love_120_50.jpg'
        }, {
            title: t('Birthday'),
            value: 'Birthday_120_50.jpg'
        }, {
            title: t('Party'),
            value: 'Party_120_50.jpg'
        }, {
            title: t('Rainbow'),
            value: 'Rainbow_120_50.jpg'
        }, {
            title: t('New Year'),
            value: 'NewYear_120_50.jpg'
        }, {
            title: t('Summer'),
            value: 'Summer_120_50.jpg'
        }, {
            title: t('Winter'),
            value: 'Winter_120_50.jpg'
        }, {
            title: t('Spring'),
            value: 'Spring_120_50.jpg'
        }, {
            title: t('Halloween'),
            value: 'Halloween_120_50.jpg'
        }
    ];
    useEffect(() => {
        setMounted(true);
        if (countdownApi && countdownApi.isCompleted()) {
            countdownApi.start()
        };

    }, [repeated, countdownApi]);



    const setCountDownInStorage = () => {
        try {

            console.log("setCountDownInStorage");
            let data_2_set = {
                id: uuidv4(),
                keyFiguration: keyFiguration,
                timepickerDefault: timepickerDefault,
                times: times,
                hideDateTitle: hideDateTitle,
                title: title,
                sound: sound,
                started: true,
                blockstyle: blockstyle,
                text_colors: {
                    date_time: colorTime,
                    digits: colorDigit,
                },
                bg: bg
            }


            const hrs = timepickerDefault.hours * 60 * 60 * 1000;
            const mins = timepickerDefault.minutes * 60 * 1000;
            const sec = timepickerDefault.seconds * 1000;
            const total_in_ms_timepickerDefault = moment().add(hrs + mins + sec, 'milliseconds').valueOf();
            let total_in_ms_raw = total_in_ms_timepickerDefault;
            let total_in_ms = moment().add(total_in_ms_raw, 'milliseconds').valueOf();
            const preparedDatetimer = moment(datetimer).set({
                hour: timepickerDefault.hours,
                minute: timepickerDefault.minutes,
                second: timepickerDefault.seconds
            });
            console.log("===timepickerDefault==", timepickerDefault);
            total_in_ms = preparedDatetimer.valueOf();
            let datetimer_ms = preparedDatetimer.valueOf();
            total_in_ms_raw = _moment.range(moment(), preparedDatetimer).diff();
            if (total_in_ms_raw < 0) {
                alert('Date must not be in the past');
                return false;
            }
            const total_in_ms_raw_left = total_in_ms_raw;
            data_2_set = {
                ...data_2_set,
                total_in_ms,
                total_in_ms_raw,
                total_in_ms_raw_left,
                datetimer: datetimer_ms
            };


            //If timer has id then need to update otherwise create new timer
            if (timerObj?.id) {
                setCountdowns([...(countdowns ? countdowns.map(v => {
                    if (v.id === timerObj?.id) {
                        delete data_2_set.id;
                        return {
                            ...v,
                            ...data_2_set
                        }
                    } else {
                        return v
                    }
                }) : [])]);
            } else {
                setCountdowns([data_2_set, ...(countdowns ? countdowns : [])]);
            }

            cancelDisplay && cancelDisplay();
            Router.reload(window.location.pathname);
            return false;

        } catch (error) {
            console.error(error);
        }


    }





    const timepickerCb = (tpdata) => {
        setTimes(null);
        console.log("===tpdata====", tpdata);
        setTimepickerDefault({
            hours: tpdata?.hours || 0,
            minutes: tpdata?.minutes || 0,
            seconds: tpdata?.seconds || 0
        });
        setDatetimer(moment(datetimer).set({
            hour: tpdata?.hours || 0,
            minute: tpdata?.minutes || 0,
            second: tpdata?.seconds || 0
        }).valueOf())

    };

    const handleRadio = (e) => {
        setKeyFiguration(e.target.value);
    }

    const handleSound = (sound) => {
        setSound(sound);
    };



    const handleClose = (event, reason) => {
        setAlarmset(false);
    };
    const handlePlay = (audio = null, action = 'play', index) => {
        try {
            previewAudio = audio ? audio : previewAudio;
            // const audio = new Audio('/iphone_alarm.mp3');
            if (action === 'play' && previewAudio) {
                setPlaying({
                    ...playing,
                    [index]: true
                })
                setPreviewAudio(audio);
                previewAudio.play();

            }

            if (action === 'stop' && previewAudio) {
                setPlaying({
                    ...playing,
                    [index]: false
                })
                previewAudio.pause();

            }
        } catch (error) {

        }
    }
    const handleTitle = (e) => {
        setTitle(e.target.value);
    }
    const handleBlockstyle = (e) => {
        setBlockstyle(e)
    }


    const start = () => {
        setStarted(true);
        countdownApi && countdownApi.start();
    };

    const stopTimer = () => {
        setStarted(false);
        countdownApi && countdownApi.stop();
    };
    const pause = () => {
        countdownApi && countdownApi.pause();
    };


    const handlePause = (e) => {
        setStarted(false);
        setTimer(Date.now() + e.total);
    }
    const handleStop = (e) => {
        setStarted(false);
        setTimer(Date.now() + initial);
    }

    const reset = () => {
        setTimer(Date.now() + initial);
    };

    const closeAlarmModal = () => {
        stop();
        setOpenAlarm(false);
        setStarted(false);
        setInitial(0);
    };

    const setRef = (countdown) => {
        if (countdown) {
            setCountdownApi(countdown.getApi());
        }
    }

    const complete = (e) => {

        setStarted(false);
        //setTimer(Date.now());
        setRepeated(false);
        setOpenAlarm(true);
        play();

        console.log("completed");
    };
    const repeat = () => {
        stop();
        setRepeated(true);
        setStarted(true);
        setOpenAlarm(false);
        setTimer(Date.now() + initial);
    };






    return (
        <>
            <div className='countdown-container'>


                { /*!exrtaProps?.fromdialog && <div className="right-operations">

                    < div className="circle" title={t('key_fullscreen')} onClick={fullscreenfn && fullscreenfn.enter}>
                {(<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0.166504 0.166992H4.33317V1.83366H1.83317V4.33366H0.166504V0.166992ZM7.6665 0.166992H11.8332V4.33366H10.1665V1.83366H7.6665V0.166992ZM10.1665 7.66699H11.8332V11.8337H7.6665V10.167H10.1665V7.66699ZM4.33317 10.167V11.8337H0.166504V7.66699H1.83317V10.167H4.33317Z" fill="#444D67" />
                </svg>

                )}
            </div>
        </div> */}
                {started && <Countdown key={`timer_key_${index ? index : 0}`} daysInHours={true} className='digital_clock_style m-bottom-20' ref={setRef} date={timer} onPause={handlePause} onStop={handleStop} onComplete={complete} autoStart={false} />}
                <div className="display-container my-container">
                    <div className="addTimer addCountDown">
                        <>
                            <div className='bg-images-color'>
                                <h4>{t('Select Background Style')}</h4>
                                <FormControl style={{ marginBottom: "8px" }}>
                                    <div className='title'>
                                        <h5>{t('Color')}</h5>
                                    </div>
                                    <div className={bg.is_color ? 'image-block image-block-selected' : 'image-block'}>
                                        <ColorPicker hideTextfield={true}
                                            value={bg.is_color ? bg.value : null}
                                            onChange={
                                                (color) => {
                                                    setBg({
                                                        is_color: true,
                                                        value: `#${color.hex}`
                                                    })
                                                }
                                            }
                                            defaultValue="transparent" />
                                    </div>

                                </FormControl>

                                <FormControl>
                                    <div className='title'>
                                        <h5>{t('Image')}</h5>
                                    </div>
                                    <div className='field bg-images'>
                                        {bgImages.map((v, i) => {
                                            return (
                                                <div key={i} className={''} onClick={() => {
                                                    setBg({
                                                        is_color: false,
                                                        value: `/images/bgimagesmy/${v.value}`,
                                                        name: v.value.split('_')['0']
                                                    })
                                                }}>
                                                    <h4>{v.title}</h4>
                                                    <div className={(!bg.is_color && bg.value === `/images/bgimagesmy/${v.value}`) ? 'image-block image-block-selected' : 'image-block'}>
                                                        <Image alt={v.title} width={'120px'} height={'50px'} src={`/images/bgimagesmy/${v.value}`} />
                                                    </div>

                                                </div>
                                            );
                                        })}
                                    </div>

                                </FormControl>
                            </div>

                            <div className='preview-container'>
                                <div className="bg-div-cover bg-big" style={bg.is_color ? { background: bg.value } : {
                                    background: `url(/images/bgimagesmy/${bg.name}_1012_270.jpg) no-repeat center center`

                                }} ></div>
                                <div className="bg-div-cover bg-middle" style={bg.is_color ? { background: bg.value } : {
                                    background: `url(/images/bgimagesmy/${bg.name}_523_236.jpg) no-repeat center center`

                                }} ></div>
                                <div className="bg-div-cover bg-small" style={bg.is_color ? { background: bg.value } : {
                                    background: `url(/images/bgimagesmy/${bg.name}_330_220.jpg) no-repeat center center`

                                }} ></div>
                                <div className="preview-container-content">
                                    {!hideDateTitle && <div style={{ color: colorTime }} className='title'>
                                        {title || t('Event name')}
                                    </div>}
                                    <div className='countdown'>
                                        <Countdown
                                            autoStart={false}
                                            daysInHours={false}
                                            onComplete={() => { }}
                                            color={colorDigit}
                                            blockstyle={blockstyle}
                                            date={datetimer}
                                            keyFiguration={keyFiguration}
                                            renderer={renderer}
                                        />
                                    </div>
                                    {!hideDateTitle && <div className='date' style={{ color: colorTime }}>
                                        {moment(datetimer).format('DD')} {t(moment(datetimer).format('MMMM'))} {moment(datetimer).format('YYYY')}
                                    </div>}
                                </div>
                            </div>

                            <div className='d-flex-raw'>
                                <div className='left-side'>

                                    <div className='left-side-content'>
                                        <div className='title-timezone'>
                                            <FormControl color="error" className=' flex-form' variant="standard">
                                                <div className='title'>
                                                    <h5>{t('title')}</h5>
                                                </div>
                                                <div className='field'>
                                                    <TextField
                                                        color="error"
                                                        className="text-input text-input-timer"
                                                        value={title}
                                                        onChange={handleTitle}
                                                    />
                                                </div>
                                            </FormControl>
                                        </div>
                                        <div className='date-time '>

                                            <FormControl className=' flex-form datepicker-input w-100 ' variant="standard">
                                                <div className='title'>
                                                    <h5>{t('date')}</h5>
                                                </div>

                                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                    <DesktopDatePicker
                                                        disablePast
                                                        inputFormat="dd.MM.yyyy"
                                                        value={datetimer}
                                                        onChange={(newValue) => {
                                                            setDatetimer(newValue);
                                                        }}
                                                        components={{
                                                            OpenPickerIcon: () => (<svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M3.83333 9.16634H5.5V10.833H3.83333V9.16634ZM15.5 4.16634V15.833C15.5 16.758 14.7583 17.4997 13.8333 17.4997H2.16667C1.24167 17.4997 0.5 16.7497 0.5 15.833V4.16634C0.5 3.24967 1.25 2.49967 2.16667 2.49967H3V0.833008H4.66667V2.49967H11.3333V0.833008H13V2.49967H13.8333C14.7583 2.49967 15.5 3.24967 15.5 4.16634ZM2.16667 5.83301H13.8333V4.16634H2.16667V5.83301ZM13.8333 15.833V7.49967H2.16667V15.833H13.8333ZM10.5 10.833V9.16634H12.1667V10.833H10.5ZM7.16667 10.833V9.16634H8.83333V10.833H7.16667ZM3.83333 12.4997H5.5V14.1663H3.83333V12.4997ZM10.5 14.1663V12.4997H12.1667V14.1663H10.5ZM7.16667 14.1663V12.4997H8.83333V14.1663H7.16667Z" fill="#152141" />
                                                            </svg>)
                                                        }}
                                                        renderInput={(params) => (
                                                            <TextField {...params} />

                                                        )}
                                                    //renderInput={(params) => <TextField {...params} />}
                                                    />
                                                </LocalizationProvider>

                                            </FormControl>

                                            <TimePicker am_pm={false} timepickerDefault={timepickerDefault} onchangeTimer={timepickerCb} />
                                        </div>
                                        <FormControl className=' style-div flex-form' variant="standard">
                                            <div className='title'>
                                                <h5>{t('Style')}</h5>
                                            </div>
                                            <div className='field'>
                                                <FormControl>
                                                    <Select
                                                        labelId="demo-simple-select-label"
                                                        className={"simple-select"}
                                                        classNamePrefix="simple-select"
                                                        placeholder={'00'}
                                                        id={"simple-select-id"}
                                                        value={blockstyle}
                                                        components={{
                                                            NoOptionsMessage,
                                                            ClearIndicator,
                                                            DropdownIndicator,
                                                            IndicatorSeparator: () => null
                                                        }}
                                                        theme={(theme) => ({
                                                            ...theme,
                                                            borderRadius: 0,
                                                            colors: {
                                                                ...theme.colors,
                                                                primary25: 'rgb(3, 201, 215)',
                                                                primary: 'rgb(3, 201, 215)',
                                                            },
                                                        })}

                                                        options={blockStyles}
                                                        isClearable={true}
                                                        onError={() => { console.log("error") }}
                                                        onErrorCapture={() => { console.log("error") }}
                                                        onKeyDown={(params) => { console.log("==parmas===", params) }}
                                                        onChange={handleBlockstyle}

                                                        styles={{
                                                            noOptionsMessage: base => {

                                                                return { ...base, color: "red" }
                                                            },

                                                            menuList: (base) => ({
                                                                ...base,
                                                                "::-webkit-scrollbar-track": {
                                                                    background: "white"
                                                                },
                                                                "::-webkit-scrollbar-thumb": {
                                                                    background: "rgb(3, 201, 215)"
                                                                },
                                                                "::-webkit-scrollbar-thumb:hover": {
                                                                    background: "rgb(3, 201, 215)"
                                                                }
                                                            })
                                                        }}
                                                    >

                                                    </Select>
                                                </FormControl>
                                            </div>
                                        </FormControl>

                                    </div>
                                </div>
                                <div className='right-side'>
                                    <div className='left-right-side'>

                                        <FormControl className='flex-form'>
                                            <div className='title for-timer-title'>
                                                <h5>{t('Settings')}</h5>
                                            </div>
                                            <div className='field timer-field'>
                                                <RadioGroup

                                                    onChange={handleRadio}
                                                    value={keyFiguration}
                                                    aria-labelledby="demo-radio-buttons-group-label"
                                                    defaultValue="countdown"
                                                    name="radio-buttons-group"
                                                >
                                                    <FormControlLabel value="countdown" control={<Radio value={'alldate'}
                                                        icon={<EmptyRadioIcon />}
                                                        checkedIcon={<FillRadioIcon />} />} label={t('Days / Hours / Minutes / Seconds')} />
                                                    <FormControlLabel value="countdowntill" control={<Radio
                                                        icon={<EmptyRadioIcon />}
                                                        checkedIcon={<FillRadioIcon />}
                                                        value={'onlydays'} />} label={t('Just days')} />

                                                </RadioGroup>
                                            </div>
                                        </FormControl>
                                        <FormControlLabel
                                            value={hideDateTitle}
                                            className="hide_date_title"
                                            control={<Checkbox color='success' icon={<EmptyBorderIcon />}
                                                checkedIcon={<FillIcon />} onChange={(e) => { setHideDateTitle(e.target.checked) }} />}
                                            label={t('Hide date and title')}
                                            labelPlacement="end"
                                        />

                                        <FormControl className=' flex-form' variant="standard">
                                            <div className='title'>
                                                <h5>{t('Text color')}</h5>
                                            </div>
                                            <div className='field'>
                                                <FormControl>
                                                    <div className='sub-title'>
                                                        <h5>{t('Title and date')}</h5>
                                                    </div>
                                                    <div className='field'>
                                                        <ColorPicker key={'sssss'} hideTextfield={true} value={colorTime} onChange={(color) => { setColorTime(`#${color.hex}`) }} defaultValue="transparent" />
                                                    </div>

                                                </FormControl>

                                                <FormControl>
                                                    <div className='sub-title'>
                                                        <h5>{t('Digits')}</h5>
                                                    </div>
                                                    <div className='field'>
                                                        <ColorPicker key={'asdsada'} hideTextfield={true} value={colorDigit} onChange={(color) => { setColorDigit(`#${color.hex}`) }} defaultValue="transparent" />
                                                    </div>

                                                </FormControl>

                                            </div>
                                        </FormControl>
                                    </div>

                                </div>
                            </div>



                        </>

                        <Snackbar
                            open={alarmset}
                            autoHideDuration={5000}
                            message={t('key_alarm_set')}
                            onClose={handleClose}
                        />
                    </div>
                    <div className='d-flex buttons-sm' style={{ flexDirection: 'row', /*width: '560px', */columnGap: '28px' }}>
                        <>
                            <div className={'btn-div'}>
                                <Button variant="outlined" onClick={setCountDownInStorage} className="w-100" >
                                    {exrtaProps?.fromdialog ? t('Save') : t('Create Countdown')}
                                </Button>

                            </div>
                            {/*<div className='regular-outlined-button'>
                                <Button className="w-100" onClick={() => { }} variant="outlined" color="success" startIcon={<svg width="19" height="15" viewBox="0 0 19 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M11.5 0V4C4.5 5 1.5 10 0.5 15C3 11.5 6.5 9.9 11.5 9.9V14L18.5 7L11.5 0ZM13.5 4.83L15.67 7L13.5 9.17V7.9H11.5C9.43 7.9 7.57 8.28 5.84 8.85C7.24 7.46 9.04 6.37 11.78 6L13.5 5.73V4.83Z" fill="#56A269" />
                                </svg>

                                }>
                                    {exrtaProps?.fromdialog ? t("Save and Share") : t("Create and Share")}
                                </Button>
                            </div>*/}

                        </>
                    </div>


                    {started && <Button variant="outlined" onClick={pause} disabled={!started} className="m-right-15" startIcon={<PauseIcon color="warning" />}>
                        {t('Pause')}
                    </Button>}
                    {started && <Button variant="outlined" onClick={stopTimer} className="m-right-15" startIcon={<DangerousIcon color="error" />}>
                        {t('Stop')}
                    </Button>}

                </div>
            </div >
            <Dialog open={openAlarm} onClose={closeAlarmModal}>
                <DialogTitle style={{ textAlign: "center" }}> {t('Timer alarm')}</DialogTitle>
                <DialogContent className="m-w-250">
                    <div style={{ textAlign: "center" }}>
                        <AccessAlarmSharpIcon fontSize="large" color="error" />
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button variant="outlined" onClick={repeat} className="m-right-15" startIcon={<LoopIcon />}>
                        {t('Repeat')}
                    </Button>
                    <Button onClick={closeAlarmModal}> {t('Close')} </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

